// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Хост тостов панели помощи — поверх ящика, канон позиционирования как у shell-update-banner. */
.shell-help-toasts {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 100; /* выше osn-hdrawer-wrap кита (95) — тост должен быть виден поверх открытого ящика */
  display: flex;
  flex-direction: column;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/help/help-toasts.css"],"names":[],"mappings":"AAAA,gGAAgG;AAChG;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY,EAAE,oFAAoF;EAClG,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV","sourcesContent":["/* Хост тостов панели помощи — поверх ящика, канон позиционирования как у shell-update-banner. */\n.shell-help-toasts {\n  position: fixed;\n  top: 16px;\n  right: 16px;\n  z-index: 100; /* выше osn-hdrawer-wrap кита (95) — тост должен быть виден поверх открытого ящика */\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
